<div class="modal-main create-user" [formGroup]="formGroup">
  <ng-container *ngIf="stepper === addDeviceNameComponent">
    <app-device-name
      formGroupName="deviceNameDetails"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    >
    </app-device-name>
  </ng-container>

  <ng-container *ngIf="stepper === deviceInformationComponent">
    <app-device-information
      formGroupName="deviceSerialDetails"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      (submitToParent)="submitToParent()"
    >
    </app-device-information>
  </ng-container>

  <ng-container *ngIf="stepper === deviceAddComponent">
    <app-device-added
      formGroupName="deviceDetails"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    >
    </app-device-added>
  </ng-container>
</div>
